/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceLocation } from './ServiceLocation';
import {
    ServiceLocationFromJSON,
    ServiceLocationFromJSONTyped,
    ServiceLocationToJSON,
    ServiceLocationToJSONTyped,
} from './ServiceLocation';

/**
 * 
 * @export
 * @interface Demographics
 */
export interface Demographics {
    /**
     * 
     */
    gender: string;
    /**
     * 
     */
    date_of_birth: string;
    /**
     * 
     */
    ssn?: string;
    /**
     * 
     */
    race?: string;
    /**
     * 
     */
    nickname?: string;
    /**
     * 
     */
    marital_status?: string;
    /**
     * 
     */
    primary_spoken_language?: string;
    /**
     * 
     */
    religion?: string;
    /**
     * 
     */
    living_arrangement?: string;
    /**
     * 
     */
    service_location: ServiceLocation;
}

/**
 * Check if a given object implements the Demographics interface.
 */
export function instanceOfDemographics(value: object): value is Demographics {
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('date_of_birth' in value) || value['date_of_birth'] === undefined) return false;
    if (!('service_location' in value) || value['service_location'] === undefined) return false;
    return true;
}

export function DemographicsFromJSON(json: any): Demographics {
    return DemographicsFromJSONTyped(json, false);
}

export function DemographicsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Demographics {
    if (json == null) {
        return json;
    }
    return {
        
        'gender': json['gender'],
        'date_of_birth': json['date_of_birth'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'race': json['race'] == null ? undefined : json['race'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'marital_status': json['marital_status'] == null ? undefined : json['marital_status'],
        'primary_spoken_language': json['primary_spoken_language'] == null ? undefined : json['primary_spoken_language'],
        'religion': json['religion'] == null ? undefined : json['religion'],
        'living_arrangement': json['living_arrangement'] == null ? undefined : json['living_arrangement'],
        'service_location': ServiceLocationFromJSON(json['service_location']),
    };
}

export function DemographicsToJSON(json: any): Demographics {
    return DemographicsToJSONTyped(json, false);
}

export function DemographicsToJSONTyped(value?: Demographics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gender': value['gender'],
        'date_of_birth': value['date_of_birth'],
        'ssn': value['ssn'],
        'race': value['race'],
        'nickname': value['nickname'],
        'marital_status': value['marital_status'],
        'primary_spoken_language': value['primary_spoken_language'],
        'religion': value['religion'],
        'living_arrangement': value['living_arrangement'],
        'service_location': ServiceLocationToJSON(value['service_location']),
    };
}

